import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { patchDataToken } from "../axios/axiosHelper";
import { toastMsg } from "../functions/toastMsg";

const INVALID_RESET_MESSAGE =
  "This password-reset link is invalid or expired. Request a new password-reset email.";

export const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [actionInvalid, setActionInvalid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "newPassword") setNewPassword(value);
    if (name === "confirmPassword") setConfirmPassword(value);
    if (!actionInvalid) setErrorMessage("");
  };

  const resetPassword = async (event) => {
    event.preventDefault();
    if (newPassword !== confirmPassword) {
      const message = "Passwords do not match";
      setErrorMessage(message);
      toastMsg(message, "error");
      return;
    }

    setLoading(true);
    setErrorMessage("");
    try {
      const response = await patchDataToken(
        "/admin/auth/resetPassword",
        { token, password: newPassword, confirmPassword },
        false
      );

      toastMsg(
        response?.data?.message || "Password reset successfully",
        "success"
      );
      navigate("/login");
    } catch (error) {
      let message;
      if (error?.response?.data?.code === "ADMIN_ACTION_TOKEN_INVALID") {
        message = INVALID_RESET_MESSAGE;
        setActionInvalid(true);
      } else if (error?.response) {
        message = error.response.data?.message || "An error occurred";
      } else if (error?.request) {
        message = "Network error, please try again later";
      } else {
        message = "An error occurred, please try again";
      }
      setErrorMessage(message);
      toastMsg(message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="d-flex justify-content-center align-items-center min-vh-100 bg-white px-3">
      <form
        className="border w-100 border-black rounded-4 py-4 px-3"
        style={{ maxWidth: "640px" }}
        onSubmit={resetPassword}
      >
        <div className="text-black">
          <h1 className="h4">Reset your password</h1>
          <p>Choose a new password for your Admin account.</p>
        </div>

        <div className="coolinput mx-auto" style={{ position: "relative" }}>
          <label htmlFor="newPassword" className="text">
            New Password:
          </label>
          <input
            id="newPassword"
            type={showNewPassword ? "text" : "password"}
            onChange={handleInputChange}
            value={newPassword}
            required
            minLength={8}
            autoComplete="new-password"
            placeholder="• • • • • •"
            name="newPassword"
            className="input"
          />
          <button
            type="button"
            onClick={() => setShowNewPassword((show) => !show)}
            aria-label={showNewPassword ? "Hide new password" : "Show new password"}
            className="border-0 bg-transparent"
            style={{
              position: "absolute",
              right: "10px",
              top: "63%",
              transform: "translateY(-50%)",
              cursor: "pointer"
            }}
          >
            <i
              aria-hidden="true"
              className={showNewPassword ? "fa fa-eye-slash" : "fa fa-eye"}
            />
          </button>
        </div>

        <div className="coolinput mx-auto" style={{ position: "relative" }}>
          <label htmlFor="confirmPassword" className="text">
            Confirm Password:
          </label>
          <input
            id="confirmPassword"
            type={showConfirmPassword ? "text" : "password"}
            onChange={handleInputChange}
            value={confirmPassword}
            required
            minLength={8}
            autoComplete="new-password"
            placeholder="• • • • • •"
            name="confirmPassword"
            className="input"
          />
          <button
            type="button"
            onClick={() => setShowConfirmPassword((show) => !show)}
            aria-label={
              showConfirmPassword
                ? "Hide password confirmation"
                : "Show password confirmation"
            }
            className="border-0 bg-transparent"
            style={{
              position: "absolute",
              right: "10px",
              top: "63%",
              transform: "translateY(-50%)",
              cursor: "pointer"
            }}
          >
            <i
              aria-hidden="true"
              className={showConfirmPassword ? "fa fa-eye-slash" : "fa fa-eye"}
            />
          </button>
        </div>

        {errorMessage ? (
          <p className="text-danger mt-3 mb-0" role="alert">
            {errorMessage}
          </p>
        ) : null}

        <div className="forgetPassword mt-3">
          <button
            type="submit"
            disabled={loading || actionInvalid}
            className="btn w-100 loginbtn btn-dark"
          >
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </div>
      </form>
    </section>
  );
};
